import { render, staticRenderFns } from "./CorporationSettings.vue?vue&type=template&id=c7783662&"
import script from "./CorporationSettings.vue?vue&type=script&lang=js&"
export * from "./CorporationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports